import React, { Component } from "react";
import $ from "jquery";
import Constant from "../../../Constant.js";

export default class BackGroundBorder extends Component {
  state = {
    image: [],
  };
  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.allImages !== this.props.allImages) {
  //     this.setState({
  //       images: this.props.allImages,
  //     })
  //   }
  // }

  componentDidMount() {
    //API for some boarder images
  }
  uploadImg = () => {
    var that = this;
    var form = $("#documents")[0];
    var data = new FormData(form);
    data.append("siteId", localStorage.getItem("lms_site_id"));
    data.append("certificate", true);
    fetch(Constant.getAPI() + "/media/add", {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("livelms_auth"),
      },
      body: data,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        if (json.status === true) {
          // that.setState({ MediumId: json.data[0].id });
          window.location.reload();
          // alert("image uploaded");
        } else {
          console.log(json.error);
        }
      });
  };

  handleCertificateImage = (file) => {
    document.getElementById("passport_image_section_lable").innerHTML = "";
    let element = $("#passport_proofs").get(0);
    $("#passport_image_section").empty();
    this.setState({ accepted: element });
    console.log(element.files);
    for (var i = 0; i < element.files.length; i++) {
      var file1 = element.files[i];
      var img = document.createElement("img");
      // img.className = "proof_img img-responsive img-circle";
      img.width = "150";
      img.height = "100";
      img.style.display = "inline-block";
      var filePath = URL.createObjectURL(file1);
      img.src = filePath;
      this.setState({ img_url: filePath });
      $("#passport_image_section").append(img);
    }
  };
  render() {
    const IMAGES = this.props.allImages.map((image) => {
      return (
        <div class="gray mt-1">
          <img
            src={image.url}
            alt="some text here"
            name={image.url}
            id={image.id}
            width="150"
            height="100"
            className={
              this.props.selectedImg === image.id ? "selected_image" : ""
            }
            onClick={this.props.handleImage}
          />
        </div>
      );
    });
    console.log("BackGroundBorder", this.state.image);
    return (
      <div class="container-fluid">
        <div class="row">
          {IMAGES}
          <div className="gray mt-1">
            <form id="documents" encType="multipart/form-data">
              <div className="text-center">
                <div className="upload-id-proof" aria-disabled="false">
                  <div id="passport_image_section_lable">
                    <h6>Upload Certificate Background Image</h6>
                  </div>
                  <div id="passport_image_section">
                    {this.state.profile_img ? (
                      this.state.profile_img !== null ||
                        this.state.profile_img !== undefined ||
                        this.state.profile_img !== "" ? (
                          <img
                            src={this.state.profile_img}
                            alt=""
                            className="img-responsive"
                            width="150"
                            height="100"
                          />
                        ) : (
                          <img src="" alt="" />
                        )
                    ) : (
                        <img src="" alt="" />
                      )}
                  </div>
                  <input
                    accept="image/*"
                    onChange={this.handleCertificateImage}
                    id="passport_proofs"
                    type="file"
                    autoComplete="off"
                    name="media"
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "0px",
                      bottom: "0px",
                      left: "0px",
                      opacity: " 1e-05",
                      width: "100%",
                    }}
                  />
                </div>
                <input
                  type="button"
                  value="upload"
                  onClick={this.uploadImg}
                  className="btn btn-info upload-btn text-capitalize"
                  style={{ display: "block" }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
